<script>
import Sidebar from './ui/Sidebar.vue'

export default {
  name: 'Contacts',
  components: {
    Sidebar
  },
  metaInfo() {
    return {
      title: this.office.metaTitle
        ? `${this.office.metaTitle} | Контакты`
        : 'Контакты'
    }
  },
  computed: {
    office() {
      return this.$store.getters['contacts/office']
    },
    loading() {
      return this.$store.getters['contacts/isOfficeLoading']
    }
  },
  created() {
    this.$store.commit('contacts/setIsOfficeLoading', true)

    this.$store.dispatch('contacts/getOffice', this.$route.params.slug)
  },
  beforeDestroy() {
    this.$store.commit('contacts/clearOfficeData')
  }
}
</script>
<template>
  <div class="page contacts">
    <div class="page__wrap">
      <div>
        <sidebar />
      </div>
      <div>
        <div class="page__content contacts">
          <b-loading
            v-if="loading"
            :is-full-page="false"
            :active="loading"
          />
          <div v-else>
            <h1 class="page__content-title">
              {{ office.title }}
            </h1>
            <h2 class="page__content-subtitle page__content-subtitle--main">
              {{ office.subtitle }}
            </h2>
            <div class="page__content-columns-2">
              <div>
                <div class="contacts__category">
                  <p class="contacts__category-title">
                    Телефоны
                  </p>
                  <div
                    v-for="(phone, index) in office.phones"
                    :key="index"
                    class="contacts__category-item"
                  >
                    <p class="contacts__category-item-title">
                      {{ phone.title }}
                    </p>
                    <a
                      :href="`tel:${phone.title}`"
                      class="contacts__category-item-link"
                    >
                      {{ phone.phone }}
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <p class="contacts__category-title">
                  Электронная почта
                </p>
                <div class="contacts__category">
                  <div class="contacts__category-item">
                    <a
                      :href="`mailto:${office.email}`"
                      class="contacts__category-item-link"
                    >
                      {{ office.email }}
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div class="contacts__category-item">
                  <p class="contacts__category-title">
                    Юридический и фактический адрес
                  </p>
                  <p class="contacts__category-item-address">
                    109004, Россия, Москва, ул. Земляной Вал, 59, стр. 2, 6 этаж
                  </p>
                </div>
              </div>
              <div>
                <div class="contacts__category-item">
                  <p class="contacts__category-title">
                    Время работы
                  </p>
                  <div class="contacts__work-hours">
                    <p>
                      <span>пн-пт:</span>
                      <span>с 11:00 до 16:00</span>
                    </p>
                    <p>
                      <span>cб:</span>
                      <span>с 09:00 до 20:00</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="office.departments.length">
              <h2 class="page__content-subtitle">
                Отделы
              </h2>
              <div class="page__content-table contacts__departments-table">
                <div class="page__content-table-header">
                  <p>Отдел</p>
                  <p>Электронная почта</p>
                  <p>Добавочный номер</p>
                </div>
                <div class="page__content-table-content">
                  <div
                    v-for="(department, index) in office.departments"
                    :key="index"
                    class="page__content-table-row"
                  >
                    <div>
                      <h3 class="page__content-table-row-title">
                        {{ department.title }}
                      </h3>
                      <p>{{ department.description }}</p>
                    </div>
                    <div>
                      <a
                        :href="`mailto:${department.email}`"
                        class="page__content-table-row-title"
                      >
                        {{ department.email }}
                      </a>
                    </div>
                    <div>
                      <h3 class="page__content-table-row-title">
                        {{ department.phone }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="contacts__map">
              <iframe
                :src="office.map"
                style="border:0;"
                allowfullscreen=""
              />
            </div>
            <h2 class="page__content-subtitle">
              Как добраться
            </h2>
            <div
              class="page__content-plain-text"
              v-html="office.route"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>